import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import AbstractMediator from "../../../core/ui/AbstractMediator";

export default class FeedbackPopupMediator extends AbstractMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._languagePack = languagePack;

        this._answersButtons = [];
        this._defaultY = 0;
        this._enabled = true;
    }

    initialize() {
        super.initialize();
        this._enabled = true;
        this._slice9Panel = new Slice9Panel(this._target.ToolTipContainer, this._target.ToolTipContainer.children.find(c => c instanceof createjs.Bitmap), { mode: Slice9Panel.VERTICAL });
    }

    setText(text) {
        this._target.ToolTipContainer.toolTipTextField.text = text;
        this._slice9Panel.update();
        let yBounds = this._slice9Panel.getBounds().height;
        this._target.ToolTipContainer.y = this._defaultY - yBounds + FeedbackPopupMediator.TOOLTIP_TEXT_CONTAINER_Y_OFFSET;
    }

    disable() {
        this._enabled = false;
    }

    enable() {
        this._enabled = true;
    }

    setDefaultY(defaultY) {
        this._defaultY = defaultY;
        this._target.ToolTipPointer.y = this._defaultY + FeedbackPopupMediator.TOOLTIP_POINTER_Y_OFFSET;
    }

    show() {
        if(this._enabled) {
            createjs.Tween.get(this._target).to({ alpha: 1 }, 450, createjs.Ease.sineOut);
        }
    }

    hide() {
        createjs.Tween.get(this._target).to({ alpha: 0 }, 450, createjs.Ease.sineOut);
    }

    destroy() {
        super.destroy();
    }

    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}
FeedbackPopupMediator.TOOLTIP_POINTER_Y_OFFSET = 13;
FeedbackPopupMediator.TOOLTIP_TEXT_CONTAINER_Y_OFFSET = 170;